import { createActions, createReducer } from 'reduxsauce';
import * as Immutable from 'seamless-immutable';
import * as R from 'ramda';

/* ------------- Types and Action Creators ------------- */
const tag = '[SAGA_OFFER_REDUX]'; // eslint-disable-line

const functionDefinitions = {

    /*---------- offerDetail --------*/
    requestOfferDetail: ['actionId', 'userId', 'propertyId'],
    offerDetailSuccess: ['offerDetailResponse'],
    offerDetailFailure: ['offerDetailError'],
    requestUpdateFinancialStatement: ['financialStatement'],

    /*---------- updateOfferDetail --------*/
    requestUpdateOfferDetail: ['offerDetail2Update', 'userId', 'actionId', 'isRedirectToContract', 'propertyId'],
    updateOfferDetailSuccess: ['updateOfferDetailResponse'],
    updateOfferDetailFailure: ['offerDetailError'],

    /*---------- deleteOfferBuyer --------*/
    requestDeleteOfferBuyer: ['buyerId', 'actionId', 'userId'],
    deleteOfferBuyerSuccess: ['deleteOfferBuyerResponse'],
    deleteOfferBuyerFailure: ['deleteOfferBuyerError'],

    /*---------- getContactBuyerInformation --------*/
    requestGetContactBuyerInformation: ['contactId'],
    getContactBuyerInformationSuccess: ['getContactBuyerInformationResponse'],
    getContactBuyerInformationFailure: ['getContactBuyerInformationError'],

    /*---------- createOffer --------*/
    requestCreateOffer: ['propertyId', 'userId', 'offer2Create', 'isRedirectToContract'],
    createOfferSuccess: ['createOfferResponse'],
    createOfferFailure: ['createOfferError'],

    /*---------- restoreOffer --------*/
    requestRestoreOffer: ['historyId', 'offerId', 'contractId', 'action', 'actionId', 'propertyId'],
    restoreOfferSuccess: ['restoreOfferResponse'],
    restoreOfferFailure: ['restoreOfferError'],

    /*---------- initialCreateOffer --------*/
    requestInitialCreateOffer: ['userId', 'propertyId'],
    initialCreateOfferSuccess: ['InitialCreateOfferResponse'],
    initialCreateOfferFailure: ['InitialCreateOfferError'],

    /*---------- generateOfferReport --------*/
    requestGenerateOfferReport: ['offerId', 'propertyId'],
    generateOfferReportSuccess: ['generateOfferReportResponse'],
    generateOfferReportFailure: ['generateOfferReportError'],

    /*---------- updateOfferDescription --------*/
    requestUpdateOfferDescription: ['offerDescription', 'userId'],
    updateOfferDescriptionSuccess: ['updateOfferDescriptionResponse'],
    updateOfferDescriptionFailure: ['updateOfferDescriptionError'],

    /*---------- updateOfferPayment --------*/
    requestUpdateOfferPayment: ['offerPayment', 'actionId', 'userId'],
    updateOfferPaymentSuccess: ['updateOfferPaymentResponse'],
    updateOfferPaymentFailure: ['updateOfferPaymentError'],

    /*---------- updateMortgageCancelationDate --------*/
    requestUpdateMortgageCancelationDate: ['offerId', 'cancelDate', 'cancelDateText'],
    updateMortgageCancelationDateSuccess: ['updateMortgageCancelationDateResponse'],
    updateMortgageCancelationDateFailure: ['updateMortgageCancelationDateError'],

    /*---------- getPreviewTextTemplate --------*/
    requestGetPreviewTextTemplate:['pdfReportId','refId','propertyId','parentType'],
    getPreviewTextTemplateSuccess:['getPreviewTextTemplateResponse'],
    getPreviewTextTemplateFailure:['getPreviewTextTemplateError'],

    /*---------- updateSellerAndBuyerInformations --------*/
    
    requestUpdateSellerAndBuyerInformations:['sellerAndBuyerInfo'],
    updateSellerAndBuyerInformationsSuccess:['updateSellerAndBuyerInformationsResponse'],
    updateSellerAndBuyerInformationsFailure:['updateSellerAndBuyerInformationsError'],

};

const { Types, Creators } = createActions(functionDefinitions);

export const SagaOfferTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const SagaOfferInitState = {
    offerDetail: [],
};

export const INITIAL_STATE = Immutable(SagaOfferInitState);

/* ------------- Reducers ------------- */

/*---------- offerDetail --------*/
export const requestOfferDetail = (state, action) => {
    return state.merge({
        offerDetailFetching: true,
        actionId: action.actionId,
        userId: action.userId,
        propertyId: action.propertyId,
        offerDetailError: null,
        offerDetailResponse: null,
        updateOfferDetailFetching: false,
        generateOfferReportResponse: null,
        updateOfferDescriptionFetching: false,
        updateOfferDescriptionResponse: null,
        updateOfferDescriptionError: null,
        updateOfferPaymentResponse: null,
        updateOfferPaymentError: null,
        updateMortgageCancelationDateResponse: null,
        updateMortgageCancelationDateError: null,
        updateOfferPaymentFetching: false,
    });
};
export const offerDetailSuccess = (state, action) => {
    return state.merge({
        offerDetailFetching: false,
        offerDetailResponse: action.offerDetailResponse,
        offerDetailError: null // if success, then set error to be NULL
    });
};
export const offerDetailFailure = (state, action) => {
    return state.merge({
        offerDetailFetching: false,
        offerDetailError: action.offerDetailError
        // do not set payload to be null, as it will cause your UI to go empty
    });
};

export const requestUpdateFinancialStatement = (state, action) => {
    const offerDetailResponse = { ...state.offerDetailResponse };
    offerDetailResponse.financialStatement = action.financialStatement;
    return state.merge(
        {
            offerDetailResponse
        });
};

/*---------- updateOfferDetail --------*/
export const requestUpdateOfferDetail = (state, action) => {
    return state.merge(
        {
            updateOfferDetailFetching: true,
            offerDetail2Update: action.offerDetail2Update,
            actionId: action.actionId,
            userId: action.userId,
            propertyId: action.propetyId,
            offerDetailError: null,
            isRedirectToContract: false,
        });
};
export const updateOfferDetailSuccess = (state, action) => {
    return state.merge(
        {
            updateOfferDetailFetching: false,
            updateOfferDetailResponse: action.updateOfferDetailResponse,
            offerDetailError: null,
        });
};
export const updateOfferDetailFailure = (state, action) => {
    return state.merge(
        {
            updateOfferDetailFetching: false,
            offerDetailError: action.offerDetailError,
        });
};

/*---------- deleteOfferBuyer --------*/
export const requestDeleteOfferBuyer = (state, action) => {
    return state.merge(
        {
            deleteOfferBuyerFetching: true,
            buyerId: action.buyerId,
            actionId: action.actionId,
            userId: action.userId,
            deleteOfferBuyerError: null,
        });
};
export const deleteOfferBuyerSuccess = (state, action) => {
    return state.merge(
        {
            deleteOfferBuyerFetching: false,
            deleteOfferBuyerResponse: action.deleteOfferBuyerResponse,
        });
};
export const deleteOfferBuyerFailure = (state, action) => {
    return state.merge(
        {
            deleteOfferBuyerFetching: false,
            deleteOfferBuyerError: action.deleteOfferBuyerError,
        });
};

/*---------- getContactBuyerInformation --------*/
export const requestGetContactBuyerInformation = (state, action) => {
    return state.merge(
        {
            getContactBuyerInformationFetching: true,
            contactId: action.contactId,
            getContactBuyerInformationError: null,
            getContactBuyerInformationResponse: null,
        });
};
export const getContactBuyerInformationSuccess = (state, action) => {
    return state.merge(
        {
            getContactBuyerInformationFetching: false,
            getContactBuyerInformationResponse: action.getContactBuyerInformationResponse,
        });
};
export const getContactBuyerInformationFailure = (state, action) => {
    return state.merge(
        {
            getContactBuyerInformationFetching: false,
            getContactBuyerInformationError: action.getContactBuyerInformationError,
        });
};

/*---------- createOffer --------*/
export const requestCreateOffer = (state, action) => {
    return state.merge(
        {
            createOfferFetching: true,
            propertyId: action.propertyId,
            userId: action.userId,
            offer2Create: action.offer2Create,
            offerDetailError: null,
            isRedirectToContract: false,
        });
};
export const createOfferSuccess = (state, action) => {
    return state.merge(
        {
            createOfferFetching: false,
            createOfferResponse: action.createOfferResponse,
            offerDetailError: null,
        });
};
export const createOfferFailure = (state, action) => {
    return state.merge(
        {
            createOfferFetching: false,
            offerDetailError: action.createOfferError,
        });
};

/*---------- restoreOffer --------*/
export const requestRestoreOffer = (state, action) => {
    return state.merge(
        {
            restoreOfferFetching: true,
            restoreOfferError: null,
            historyId: action.historyId,
            offerId: action.offerId,
            contractId: action.contractId,
            action: action.action,
            actionId: action.actionId,
            propertyId: action.propertyId,
            restoreOfferResponse: null
        });
};
export const restoreOfferSuccess = (state, action) => {
    return state.merge(
        {
            restoreOfferFetching: false,
            restoreOfferResponse: action.restoreOfferResponse,
        });
};
export const restoreOfferFailure = (state, action) => {
    return state.merge(
        {
            restoreOfferFetching: false,
            restoreOfferError: action.restoreOfferError,
        });
};

/*---------- initialCreateOffer --------*/
export const requestInitialCreateOffer = (state, action) => {
    return state.merge(
        {
            initialCreateOfferFetching: true,
            userId: action.userId,
            propertyId: action.propertyId,
            InitialCreateOfferResponse: null,
            offerDetailError: null
        });
};
export const initialCreateOfferSuccess = (state, action) => {
    return state.merge(
        {
            initialCreateOfferFetching: false,
            InitialCreateOfferResponse: action.InitialCreateOfferResponse,
        });
};
export const initialCreateOfferFailure = (state, action) => {
    return state.merge(
        {
            initialCreateOfferFetching: false,
            offerDetailError: action.offerDetailError,
        });
};

/*---------- generateOfferReport --------*/
export const requestGenerateOfferReport = (state, action) => {
    return state.merge(
        {
            generateOfferReportFetching: true,
            offerId: action.offerId,
            propertyId: action.propertyId,
            generateOfferReportResponse: null,
            generateOfferReportError: null,
        });
};
export const generateOfferReportSuccess = (state, action) => {
    return state.merge(
        {
            generateOfferReportFetching: false,
            generateOfferReportResponse: action.generateOfferReportResponse,
        });
};
export const generateOfferReportFailure = (state, action) => {
    return state.merge(
        {
            generateOfferReportFetching: false,
            generateOfferReportError: action.generateOfferReportError,
        });
};

/*---------- updateOfferDescription --------*/
export const requestUpdateOfferDescription = (state, action) => {
    return state.merge(
        {
            updateOfferDescriptionFetching: true,
            offerDescription: action.offerDescription,
            userId: action.userId,
            updateOfferDescriptionError: null,
            updateOfferDescriptionResponse: null,
        });
};
export const updateOfferDescriptionSuccess = (state, action) => {
    return state.merge(
        {
            updateOfferDescriptionFetching: false,
            updateOfferDescriptionResponse: action.updateOfferDescriptionResponse,
        });
};
export const updateOfferDescriptionFailure = (state, action) => {
    return state.merge(
        {
            updateOfferDescriptionFetching: false,
            updateOfferDescriptionError: action.updateOfferDescriptionError,
        });
};

/*---------- updateOfferPayment --------*/
export const requestUpdateOfferPayment = (state, action) => {
    return state.merge(
        {
            updateOfferPaymentFetching: true,
            offerPayment: action.offerPayment,
            actionId: action.actionId,
            userId: action.userId,
            updateOfferPaymentResponse: null,
            updateOfferPaymentError: null,
        });
};
export const updateOfferPaymentSuccess = (state, action) => {
    return state.merge(
        {
            updateOfferPaymentFetching: false,
            updateOfferPaymentResponse: action.updateOfferPaymentResponse,
            offerDetailResponse: action.updateOfferPaymentResponse
        });
};
export const updateOfferPaymentFailure = (state, action) => {
    return state.merge(
        {
            updateOfferPaymentFetching: false,
            updateOfferPaymentError: action.updateOfferPaymentError,
        });
};


/*---------- updateMortgageCancelationDate --------*/
export const requestUpdateMortgageCancelationDate = (state, action) => {
    return state.merge(
        {
            updateMortgageCancelationDateFetching: true,
            offerId: action.offerId,
            cancelDate: action.cancelDate,
            cancelDateText: action.cancelDateText,
            updateMortgageCancelationDateResponse: null,
            updateMortgageCancelationDateError: null,
        });
};
export const updateMortgageCancelationDateSuccess = (state, action) => {
    return state.merge(
        {
            updateMortgageCancelationDateFetching: false,
            updateMortgageCancelationDateResponse: action.updateMortgageCancelationDateResponse,
        });
};
export const updateMortgageCancelationDateFailure = (state, action) => {
    return state.merge(
        {
            updateMortgageCancelationDateFetching: false,
            updateMortgageCancelationDateError: action.updateMortgageCancelationDateError,
        });
};

/*---------- getPreviewTextTemplate --------*/
export const requestGetPreviewTextTemplate = (state, action) => {
    return state.merge(
        {
            getPreviewTextTemplateFetching: true,
            pdfReportId: action.pdfReportId,
            refId: action.refId,
            propertyId: action.propertyId,
            parentType: action.parentType,
            getPreviewTextTemplateResponse: null,
            getPreviewTextTemplateError: null,
        });
};
export const getPreviewTextTemplateSuccess = (state, action) => {
    return state.merge(
        {
            getPreviewTextTemplateFetching: false,
            getPreviewTextTemplateResponse: action.getPreviewTextTemplateResponse,
        });
};
export const getPreviewTextTemplateFailure = (state, action) => {
    return state.merge(
        {
            getPreviewTextTemplateFetching: false,
            getPreviewTextTemplateError: action.getPreviewTextTemplateError,
        });
};

/*---------- updateSellerAndBuyerInformations --------*/


export const requestUpdateSellerAndBuyerInformations = (state,action) => {
  return state.merge(
    {
        updateSellerAndBuyerInformationsFetching:true,
        sellerAndBuyerInfo:action.sellerAndBuyerInfo,
        updateSellerAndBuyerInformationsError:null,
        updateSellerAndBuyerInformationsResponse:null,
        
    });
};
export const updateSellerAndBuyerInformationsSuccess = (state,action) => {
    return state.merge(
        {
            updateSellerAndBuyerInformationsFetching:false,
            updateSellerAndBuyerInformationsResponse:action.updateSellerAndBuyerInformationsResponse,        
        });
};
export const updateSellerAndBuyerInformationsFailure = (state,action) => {
  return state.merge(
    {
        updateSellerAndBuyerInformationsFetching:false,
        updateSellerAndBuyerInformationsError:action.updateSellerAndBuyerInformationsError,
        
    });
};



/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
    /*---------- offerDetail --------*/
    [Types.REQUEST_OFFER_DETAIL]: requestOfferDetail,
    [Types.OFFER_DETAIL_SUCCESS]: offerDetailSuccess,
    [Types.OFFER_DETAIL_FAILURE]: offerDetailFailure,
    [Types.REQUEST_UPDATE_FINANCIAL_STATEMENT]: requestUpdateFinancialStatement,

    /*---------- updateOfferDetail --------*/
    [Types.REQUEST_UPDATE_OFFER_DETAIL]: requestUpdateOfferDetail,
    [Types.UPDATE_OFFER_DETAIL_SUCCESS]: updateOfferDetailSuccess,
    [Types.UPDATE_OFFER_DETAIL_FAILURE]: updateOfferDetailFailure,

    /*---------- deleteOfferBuyer --------*/
    [Types.REQUEST_DELETE_OFFER_BUYER]: requestDeleteOfferBuyer,
    [Types.DELETE_OFFER_BUYER_SUCCESS]: deleteOfferBuyerSuccess,
    [Types.DELETE_OFFER_BUYER_FAILURE]: deleteOfferBuyerFailure,

    /*---------- getContactBuyerInformation --------*/
    [Types.REQUEST_GET_CONTACT_BUYER_INFORMATION]: requestGetContactBuyerInformation,
    [Types.GET_CONTACT_BUYER_INFORMATION_SUCCESS]: getContactBuyerInformationSuccess,
    [Types.GET_CONTACT_BUYER_INFORMATION_FAILURE]: getContactBuyerInformationFailure,

    /*---------- createOffer --------*/
    [Types.REQUEST_CREATE_OFFER]: requestCreateOffer,
    [Types.CREATE_OFFER_SUCCESS]: createOfferSuccess,
    [Types.CREATE_OFFER_FAILURE]: createOfferFailure,

    /*---------- restoreOffer --------*/
    [Types.REQUEST_RESTORE_OFFER]: requestRestoreOffer,
    [Types.RESTORE_OFFER_SUCCESS]: restoreOfferSuccess,
    [Types.RESTORE_OFFER_FAILURE]: restoreOfferFailure,

    /*---------- initialCreateOffer --------*/
    [Types.REQUEST_INITIAL_CREATE_OFFER]: requestInitialCreateOffer,
    [Types.INITIAL_CREATE_OFFER_SUCCESS]: initialCreateOfferSuccess,
    [Types.INITIAL_CREATE_OFFER_FAILURE]: initialCreateOfferFailure,

    /*---------- generateOfferReport --------*/
    [Types.REQUEST_GENERATE_OFFER_REPORT]: requestGenerateOfferReport,
    [Types.GENERATE_OFFER_REPORT_SUCCESS]: generateOfferReportSuccess,
    [Types.GENERATE_OFFER_REPORT_FAILURE]: generateOfferReportFailure,

    /*---------- updateOfferDescription --------*/
    [Types.REQUEST_UPDATE_OFFER_DESCRIPTION]: requestUpdateOfferDescription,
    [Types.UPDATE_OFFER_DESCRIPTION_SUCCESS]: updateOfferDescriptionSuccess,
    [Types.UPDATE_OFFER_DESCRIPTION_FAILURE]: updateOfferDescriptionFailure,

    /*---------- updateOfferPayment --------*/
    [Types.REQUEST_UPDATE_OFFER_PAYMENT]: requestUpdateOfferPayment,
    [Types.UPDATE_OFFER_PAYMENT_SUCCESS]: updateOfferPaymentSuccess,
    [Types.UPDATE_OFFER_PAYMENT_FAILURE]: updateOfferPaymentFailure,

    /*---------- updateMortgageCancelationDate --------*/
    [Types.REQUEST_UPDATE_MORTGAGE_CANCELATION_DATE]: requestUpdateMortgageCancelationDate,
    [Types.UPDATE_MORTGAGE_CANCELATION_DATE_SUCCESS]: updateMortgageCancelationDateSuccess,
    [Types.UPDATE_MORTGAGE_CANCELATION_DATE_FAILURE]: updateMortgageCancelationDateFailure,

    /*---------- getPreviewTextTemplate --------*/
    [Types.REQUEST_GET_PREVIEW_TEXT_TEMPLATE]: requestGetPreviewTextTemplate,
    [Types.GET_PREVIEW_TEXT_TEMPLATE_SUCCESS]: getPreviewTextTemplateSuccess,
    [Types.GET_PREVIEW_TEXT_TEMPLATE_FAILURE]: getPreviewTextTemplateFailure,

    /*---------- updateSellerAndBuyerInformations --------*/
    
    [Types.REQUEST_UPDATE_SELLER_AND_BUYER_INFORMATIONS]: requestUpdateSellerAndBuyerInformations,
    [Types.UPDATE_SELLER_AND_BUYER_INFORMATIONS_SUCCESS]: updateSellerAndBuyerInformationsSuccess,
    [Types.UPDATE_SELLER_AND_BUYER_INFORMATIONS_FAILURE]: updateSellerAndBuyerInformationsFailure,

});



// WEBPACK FOOTER //
// ./src/redux/sagaOffer/sagaOfferRedux.ts